import constants from 'constants/constants';
import moment from 'moment-timezone';

// In development, Bryntum PDF export server URL comes from REACT_APP_BRYNTUM_PDF_EXPORT_SERVER (e.g. in .85.env).
// In production builds, it is the current page origin (same host you loaded the app from).
export function getBryntumPdfExportServerUrl(): string | undefined {
    const url = new URL(document.URL);
    let exportServer = '';
    try {
        exportServer =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_BRYNTUM_PDF_EXPORT_SERVER || ''
                : `${url.origin}/exportPdf`;
    } catch (error) {
        console.log(`please check env.js exists and is not broken.  ${error}`);
    }
    return exportServer || undefined;
}

// Removes port from export server url if it appears.
function removePortFromUrl(exportServerUrl: string): string {
    const parsed = new URL(exportServerUrl, new URL(document.URL).origin);
    return `${parsed.protocol}//${parsed.hostname}`;
}

export function ganttPdfHeaderTemplate(headerContext: { currentPage?: number; totalPages?: number }): string {
    const { currentPage, totalPages } = headerContext;
    const laterPage = typeof currentPage === 'number' && currentPage > 0;
    const pageNote =
        totalPages && typeof currentPage === 'number' && currentPage >= 0
            ? ` · Page ${currentPage + 1} of ${totalPages}`
            : '';
    const stamp = moment().format(`${constants.formats.date.default} HH:mm`);
    const mainTitle = laterPage
        ? ''
        : `<div style="font-size:20px;font-weight:600;color:#111827;text-align:center;width:100%;">Schedule Visualization</div>`;

    return `<div class="b-program-chart-export-header" style="font-family: system-ui, -apple-system, 'Segoe UI', sans-serif;">
    ${mainTitle}
    <div style="font-size:11px;color:#4b5563;margin-top:${laterPage ? '0' : '6px'};text-align:left;">${stamp}${pageNote}</div>
</div>`;
}

const ganttPdfFooterTemplate = () =>
    `<div class="demo-export-footer" style="text-align:center;"><h3>© ${new Date().getFullYear()} FORESIGHT</h3></div>`;

export const ganttPdfStyles = `<style>
    html { background: #ffffff !important; }
    body.b-export { background: #ffffff !important; color: #111827; }
    .b-export-content { background: #ffffff; min-height: 100%; }
    .b-export-header { box-sizing: border-box; background: #ffffff; padding: 10px 14px; border-bottom: 1px solid #d1d5db; }
    .b-export-body, .b-export-viewport { background: #ffffff; }
</style>`;

const hiddenPdfExportDialog = {
    scheduleRangeField: { hidden: true, value: 'currentview' },
    rangesContainer: { hidden: true },
    exporterTypeField: { hidden: true, value: 'multipagevertical' },
    alignRowsField: { hidden: true, checked: true },
    repeatHeaderField: { hidden: true, checked: true },
    fileFormatField: { hidden: true, value: 'pdf' },
    paperFormatField: { hidden: true, value: 'A4' },
    orientationField: { hidden: true, value: 'landscape' },
};

export function buildGanttPdfExportConfiguration() {
    const exportServerUrl = getBryntumPdfExportServerUrl();
    const exportServerUrlWithoutPort = exportServerUrl ? removePortFromUrl(exportServerUrl) : '';

    return (
        exportServerUrl && {
            exportServer: exportServerUrl,
            clientURL: new URL(document.URL).origin,
            translateURLsToAbsolute: exportServerUrlWithoutPort || true,
            fileName: 'Schedule visualization',
            fileFormat: 'pdf',
            exporterType: 'multipagevertical',
            paperFormat: 'A4',
            orientation: 'landscape',
            scheduleRange: 'currentview',
            alignRows: true,
            repeatHeader: true,
            headerTpl: ganttPdfHeaderTemplate,
            footerTpl: ganttPdfFooterTemplate,
            filterStyles: (tags: string[]) => [...tags, ganttPdfStyles],
            exportDialog: { items: hiddenPdfExportDialog },
        }
    );
}
